import * as React from "react"
import type { LucideIcon } from "lucide-react"
import { cn } from "@/lib/utils"

export interface EmptyStateProps {
  icon?: LucideIcon
  title?: React.ReactNode
  body?: React.ReactNode
  action?: React.ReactNode
  className?: string
}

export function EmptyState({ icon: Icon, title, body, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-1 min-h-0 flex-col items-center justify-center text-center px-6 py-12 gap-3",
        className
      )}
    >
      {Icon && (
        <div className="h-12 w-12 rounded-full bg-muted/60 flex items-center justify-center text-muted-foreground motion-safe:animate-in motion-safe:fade-in motion-safe:zoom-in-95 motion-safe:duration-300">
          <Icon size={22} strokeWidth={1.5} />
        </div>
      )}
      {title && <h3 className="text-section text-foreground max-w-sm text-balance">{title}</h3>}
      {body && (
        <p className="text-body text-muted-foreground max-w-sm text-balance leading-relaxed">{body}</p>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
